export default __webpack_public_path__ + "static/media/camp1.1b08abbc.png";